import { render } from "./DividendsHistory.vue?vue&type=template&id=7cee57d8&scoped=true"
import script from "./DividendsHistory.vue?vue&type=script&lang=js"
export * from "./DividendsHistory.vue?vue&type=script&lang=js"

import "./DividendsHistory.vue?vue&type=style&index=0&id=7cee57d8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cee57d8"]])

export default __exports__